module.exports = __webpack_public_path__ + "static/media/sentry.7da558d0.svg";